<template>
  <div id="app">
    <AppBar :OnOff="Bar" :status="Status" />
    <Kv class="section" />
    <About class="section" />
    <Data class="section" />
    <BtnBar class="section" />
    <Recipe class="section" id="curry" :Num="0" ref="p1"/>
    <Recipe class="section" id="maho" :Num="1" ref="p2"/>
    <Recipe class="section" id="nabe" :Num="2" ref="p3"/>
    <Gintonic class="section" ref="end"/>
    <Footer class="section" />
  </div>
</template>

<script>
import AppBar from '@/components/appbar.vue'
import Kv from '@/components/kv.vue'
import About from '@/components/sections/about.vue'
import Data from '@/components/sections/data.vue'
import BtnBar from '@/components/sections/btn-bar.vue'
import Recipe from '@/components/recipe.vue'
import Gintonic from '@/components/sections/gintonic.vue'
import Footer from '@/components/sections/footer.vue'


export default {
  name: 'Main',
  components: {
    Kv,
    AppBar,
    About,
    Data,
    BtnBar,
    Recipe,
    Gintonic,
    Footer
  },
  data(){
    return{
      Bar: false,
      Status: [
        false,
        true,
        true,
      ]
    } 
  },
  created(){
    //window.addEventListener('scroll', this.Scroll)
  },
  methods:{
    /*Scroll(){
      const Scroll = window.scrollY
      const WH = window.innerHeight
      const p1 = this.$refs.p1.$el.offsetTop - WH;
      const p2 = this.$refs.p2.$el.offsetTop;
      const p3 = this.$refs.p3.$el.offsetTop;
      const end = this.$refs.end.$el.offsetTop -WH;
      if(Scroll<p1){
        this.Bar = false
      }
      if(Scroll>=p1 && Scroll<=p2){
        this.Bar = true
        this.Status= [false, true, true]
      }
      if(Scroll>=p2 && Scroll<=p3){
        this.Bar = true
        this.Status= [true, false, true]
      }
      if(Scroll>=p3 && Scroll<=end){
        this.Bar = true
        this.Status= [true, true, false]
      }
      if(Scroll > end){
        this.Bar = false
      }
    }*/
  },
  mounted(){    
  }
}
</script>

<style lang="scss">
#app{
  width: 100vw;
}
</style>